import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCaretDown = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m23.37 11.12-8.75 8.75a.876.876 0 0 1-1.24 0l-8.75-8.75a.876.876 0 0 1 1.24-1.24L14 18.014l8.13-8.132a.875.875 0 1 1 1.24 1.238Z" />
  </svg>
);
export default SvgCaretDown;
